 /********************
** Section Name: Swiper Logo V1
** File Name: mgm-logo-slider
** Library Used: Swiper Js
*********************/
var mgm_logo_container = new Swiper('.mgm_logo-container', {
    slidesPerView : 6,
    spaceBetween : 0,
    speed : 3000,
    
    autoplay : {
    delay : 0,
    },
    loop : true,
    slidesPerView : 'auto',
    allowTouchMove : false,
    disableOnInteraction : true
});


/********************
** Section Name: Featured Collection V1
** File Name: mgm-featured_collection
** Library Used: Swiper Js
*********************/
var mgm_swiper_prdgrid_container = new Swiper('.mgm_swiper_prdgrid-container', {
  slidesPerView : 5,
  centeredSlides : true,
 
  loop : true,
  pagination : {
      el : '.mgm_swiper-pagination',
      clickable : true,
        dynamicBullets: true,
       
  },
  navigation : {
      nextEl : '.mgm_swiper-button-next',
      prevEl : '.mgm_swiper-button-prev',
  },
  breakpoints: {
      // when window width is >= 1200px
      1200 : {
        slidesPerView: 5,
       // spaceBetween: 20
      },
      // when window width is >= 992px
      992 : {
        slidesPerView: 4
      },
      // when window width is >= 576px
      576 : {
        slidesPerView: 3
      },
      // when window width is >= 320px
      320 : {
        slidesPerView: 2
      }
  }

});



/********************
** Section Name: Testimonials V1
** File Name: mgm-testimonials
** Library Used: Swiper Js
*********************/
var mgm_swiper_quote_container = new Swiper('.mgm_swiper_quote-container', {
  slidesPerView : 1,
   loop : true,
    
    pagination : {
        el : '.mgm_swiper_quote-pagination',
        clickable : true,
        dynamicBullets: true,
       
    },
    navigation : {
        nextEl : '.mgm_swiper_quote-button-next',
        prevEl : '.mgm_swiper_quote-button-prev',
    },
  breakpoints: {
      // when window width is >= 767px
      767 : {
        slidesPerView: 2,
      }
  }

});



var mgm_swiper_science_row = new Swiper('.science-swiper', {
    slidesPerView : 3,
   loop : true,
  direction: "horizontal",
  spaceBetween: '20px',
  autoplay: {
            delay: 2500,
            disableOnInteraction: false,
          },
    pagination : {
        el : '.mgm_swiper_quote-pagination',
        clickable : true,
        dynamicBullets: true,
       
    },
    navigation : {
        nextEl : '.mgm_swiper_quote-button-next',
        prevEl : '.mgm_swiper_quote-button-prev',
    },
  breakpoints: {
      320  : {
        slidesPerView: 1,
      },
      768  : {
        slidesPerView: 2,
      },
      992  : {
        slidesPerView: 3,
      },
  },

});
/********************
** Section Name: Swiper Logo Content V3
** File Name: mgm-logo-sliderv3
** Library Used: Swiper Js
*********************/
if (document.querySelectorAll('.mgm_logo-container_slide').length > 0) {

  var mgm_logo_container = new Swiper('.mgm_logo-container_slide', {
      slidesPerView : 6,
      spaceBetween : 0,
      speed : 3000,
      
      autoplay : {
      delay : 0,
      },
      loop : true,
      slidesPerView : 'auto',
      allowTouchMove : false,
      disableOnInteraction : true
  });
}

/********************
** Section Name: testimonial section
** File Name: mgm-testimonial-section
** Library Used: Swiper Js
*********************/
if (document.querySelectorAll('.mgm-testimonial-container').length > 0) {

  var mgm_logo_container = new Swiper('.mgm-testimonial-container', {
      slidesPerView : 6,
      spaceBetween : 0,
      speed : 3000,
      
      autoplay : {
      delay : 0,
      },
      loop : true,
      slidesPerView : 'auto',
      allowTouchMove : false,
      disableOnInteraction : true,
      breakpoints: {
        320  : {
          slidesPerView: 1,
        },
        600  : {
          slidesPerView: 2,
        },
        992  : {
          slidesPerView: 3,
        },
    }
  });
}
/********************
** Description: AOS Animation
*********************/
AOS.init();

    document.addEventListener('DOMContentLoaded', function() {
      const leftBlocks = document.querySelectorAll('.left-block .scroll-content');
      const scrollImage = document.getElementById('scroll_image');


      window.addEventListener('scroll', function() {
          let activeSectionIndex = -1;
          const windowHeight = window.innerHeight;
          const offset = windowHeight * 0.7; // Adjust this value if needed

          leftBlocks.forEach((block, index) => {
              const rect = block.getBoundingClientRect();
              if (rect.top >= -offset && rect.bottom <= windowHeight + offset) {
                  activeSectionIndex = index;
              }
          });

         const activeBlock = document.querySelector('.scroll-content.active');
          if (activeSectionIndex !== -1) {
              const activeBlock = leftBlocks[activeSectionIndex];
              const activeBlockImage = activeBlock.getAttribute('data-img');
              scrollImage.querySelector('img').src = activeBlockImage;
              leftBlocks.forEach(content => content.classList.remove('active'));
              activeBlock.classList.add('active');
          } else {
            //  scrollImage.querySelector('img').src = defaultImage;

             const activeBlock = document.querySelector('.scroll-content.active');
            if (activeBlock) {
                const activeBlockImage = activeBlock.getAttribute('data-img');
                scrollImage.querySelector('img').src = activeBlockImage;

            }
          }
      });

      //  for product page description tab
    var tabs = document.querySelectorAll('.product__description .tabs a');

    // Initialize the first tab and content as active
    if (tabs.length > 0) {
        tabs[0].parentNode.classList.add('active_desc');
        var firstTabId = tabs[0].getAttribute('href');
        document.querySelector(firstTabId).classList.add('active_desc');
    }

    tabs.forEach(function(tab) {
        tab.addEventListener('click', function(e) {
            e.preventDefault(); // Prevent the default anchor behavior

            // Remove active_desc class from all contents
            var contents = document.querySelectorAll('.product__description .tabs-content');
            contents.forEach(function(content) {
                content.classList.remove('active_desc');
            });

            // Remove active_desc class from all tab list items
            document.querySelectorAll('.tabs li').forEach(function(li) {
                li.classList.remove('active_desc');
            });

            // Get the href attribute of the clicked tab, which is the ID of the target content
            var tabId = this.getAttribute('href');

            // Add active_desc class to the corresponding tabs-content div
            document.querySelector(tabId).classList.add('active_desc');

            // Add active_desc class to the clicked tab's parent li
            this.parentNode.classList.add('active_desc');
        });
    });
  });

// collection page js 
 $(document).ready(function() {
    $('.filter_drawer').click(function(event) {
        event.preventDefault(); // Prevent the default action
        // Toggle 'filter_drawer_open' class on the clicked .filter_drawer element and the drawer
        $(this).addClass('filter_drawer_open');
        
		 let $customFilterMobile = $(this).next('.custom-filter-mobile');
        $customFilterMobile.addClass('filter_drawer_open');

        // Additionally, toggle 'filter_drawer_open' class on the ul.tag-filters inside the .custom-filter-mobile
        $customFilterMobile.find('ul.tag-filters').addClass('filter_drawer_open');
    });

    // Handling the close button click
    $('.close-drawer').click(function() {
        var $drawer = $(this).parent('.custom-filter-mobile');
    $drawer.removeClass('filter_drawer_open');

    // Optional: If you also want to remove the class from the filter_drawer button itself
    $('.filter_drawer').removeClass('filter_drawer_open');
    
    // If you specifically need to remove a class from the ul.tag-filters for some reason:
    $drawer.find('ul.tag-filters').removeClass('filter_drawer_open');
		 
    });
});


/********************
** Section Name: Single Product Slider section
** File Name: mgm-product-section
** Library Used: Swiper Js
*********************/

document.addEventListener("DOMContentLoaded", function() {
  var gallerySlider = new Swiper('.gallery-slider', {
   slidesPerView: 1.901,
      spaceBetween: 0,
      initialSlide: 1,
      slidesPerGroup: 1,
    centeredSlides: true,
   
    spaceBetween: 100,
    loop: false,
	autoHeight: false,   
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      575: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      880: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 3,
      },
    }
  });

  var galleryThumbs = new Swiper('.gallery-thumbs', {
     slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: 1,
      slidesPerGroup: 1,
    centeredSlides: true,
    loop: false,
	autoHeight: true,   
    slideToClickedSlide: true,
  });

  gallerySlider.controller.control = galleryThumbs;
  galleryThumbs.controller.control = gallerySlider;
});
